var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6866 3.07814L9.26714 7.49756L13.6866 11.917C13.921 12.1514 14.0527 12.4693 14.0527 12.8009C14.0527 13.1324 13.921 13.4503 13.6866 13.6847C13.4521 13.9192 13.1342 14.0509 12.8027 14.0509C12.4711 14.0509 12.1532 13.9192 11.9188 13.6847L7.49937 9.26533L3.07995 13.6847C2.84553 13.9192 2.52759 14.0509 2.19607 14.0509C1.86455 14.0509 1.5466 13.9192 1.31218 13.6847C1.07776 13.4503 0.946069 13.1324 0.946069 12.8009C0.946069 12.4693 1.07776 12.1514 1.31218 11.917L5.7316 7.49756L1.31218 3.07814C1.07776 2.84372 0.946068 2.52578 0.946067 2.19426C0.946068 1.86274 1.07776 1.5448 1.31218 1.31037C1.5466 1.07595 1.86455 0.944258 2.19607 0.944258C2.52759 0.944258 2.84553 1.07595 3.07995 1.31037L7.49937 5.72979L11.9188 1.31038C12.1532 1.07595 12.4711 0.944258 12.8027 0.944258C13.1342 0.944258 13.4521 1.07595 13.6866 1.31038C13.921 1.5448 14.0527 1.86274 14.0527 2.19426C14.0527 2.52578 13.921 2.84372 13.6866 3.07814Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.42dda56e4e6232682783715fe8a0d5f0.svg";
export { ForwardRef as ReactComponent };